/**
 * @generated SignedSource<<80e7cc0fd0c74d86eaa2f37ad960995f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GSNForContentSidebar$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Apps" | "Nav4Filters" | "Nav4Operations" | "Nav4Overviews" | "Nav4Plans" | "Nav4Projects" | "useNetworkSideNavUserData">;
  readonly " $fragmentType": "GSNForContentSidebar";
};
export type GSNForContentSidebar$key = {
  readonly " $data"?: GSNForContentSidebar$data;
  readonly " $fragmentSpreads": FragmentRefs<"GSNForContentSidebar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "GSNForContentSidebar",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "useNetworkSideNavUserData"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Apps"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Filters"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Operations"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Overviews"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Plans"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Projects"
    }
  ],
  "type": "Query"
};

(node as any).hash = "70a6890aa949e004bca139590be37386";

export default node;
